import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[appRowspan]'
})
export class RowspanDirective implements OnInit {
  @Input() appRowspan: number;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    if (this.appRowspan) {
      this.renderer.setAttribute(this.el.nativeElement, 'rowspan', this.appRowspan.toString());
    }
  }
}